import React from "react";
import { appVersion } from "./config";

export default function AboutDisplay(props) {
    let disp;
    if (appVersion === 'public') {
        disp = (
            <div className="text-left text-sm font-normal mx-auto my-2 md:w-full bg-city-green-light/70 rounded-md p-2">
                This educational tool provides an estimate of your tax bill if the Land Value Tax proposal were in effect in 2023.
                These estimates are based on the current proposal in the Michigan State Legislature, which will also require City Council and voter approval.
                <br /><br />Please review the following definitions, which provide further context for the search results provided in this tool.
                This website is an educational tool only. Actual taxes owed are sent on the official property tax notices.
                <br /><br />
                This website only searches for properties with residential homes and buildings.
                <br /><br />
                <div className="mt-2 font-bold hover:underline cursor-pointer" onClick={() => props.setSelected('defs')}>
                    View Definitions
                </div>
            </div>
        )
    } else {
        disp = (
            <div className="text-left text-sm font-normal mx-auto my-2 md:w-full bg-city-green-light/70 rounded-md p-2">
                This educational tool provides an estimate of your tax bill if the Land Value Tax proposal were in effect in 2023.
                These estimates are based on the current proposal in the Michigan State Legislature, which will also require City Council and voter approval.
                <br /><br />Please review the following definitions, which provide further context for the search results provided in this tool.
                This website is an educational tool only. Actual taxes owed are sent on the official property tax notices.
                <div className="mt-2 font-bold hover:underline cursor-pointer" onClick={() => props.setSelected('defs')}>
                    View Definitions
                </div>
            </div>
        )
    }

    return (
        disp
    )
}